import React from 'react';
import css from './Spacer.module.scss';

export const Spacer = React.memo(() => <div id={'spacer'} className={css.spacer} />);
